import moment from 'moment';
import { roomService } from '../network/services/room.service';
import {ResponseError} from "../network/response/response-error";
import {DISABLE_ROOM_IF_ON_CART, ONLY_SAME_ZONE_BOOKABLE} from "../helpers/config";

export default {
  namespaced: true,
  state: {
    loading: false,
    results: [],
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload;
    },
  },
  actions: {
    async fetch(context, data = {}) {
      context.commit('SET_LOADING', true);
      if (!context.rootState.preFetchRoom.hasData || data.reload) {
        await context.dispatch('preFetchRoom/fetch', context.rootState.preFetchRoom.input, { root: true });
      }

      let roomIds = context.rootState.preFetchRoom.roomIds;
      const dates = context.rootState.preFetchRoom.dates;
      const input = context.rootState.preFetchRoom.input;
      const sameDate = context.rootState.preFetchRoom.input.sameDate;


      const currentShoppingCart = context.rootState.shoppingCart.shoppingCart.bookings;
      if (DISABLE_ROOM_IF_ON_CART) {
        for (const booking of currentShoppingCart) {
          const start = booking.start.slice(0,10);
          const end = booking.end.slice(0,10);
          for (const date of dates) {
            if (date >= start && dates < end) {
              roomIds = roomIds.filter(id => id !== booking.room.id);
            }
          }
        }
      }

      const nbGuest = context.rootState.preFetchRoom.nbGuest;
      const lang = context.rootState.lang.currentLang;
      context.commit('SET_RESULTS', []);
      const response = await roomService.fetchPreBookableGroupsInfos(roomIds, dates, lang, nbGuest, input, sameDate);
      let roomGroups = response.get('RoomGroup.many', []);
      if (ONLY_SAME_ZONE_BOOKABLE) {
        let availableProvider = null;
        //this.$store.commit('');
        if (currentShoppingCart.length > 0) {
          availableProvider = currentShoppingCart[0].room.provider;
        }
        roomGroups = roomGroups.map((roomGroup) => {
          roomGroup.rooms = roomGroup.rooms.filter(room => room.provider === availableProvider || availableProvider === null)
          return roomGroup;
        }).filter(roomGroups => roomGroups.rooms.length > 0);
      }

      if (!(roomGroups instanceof ResponseError)) {
        const positions = [].concat(...roomGroups.map(roomGroup => [].concat(...roomGroup.rooms.map(r => ({
          lat: r.position.lat,
          lng: r.position.lng,
          name: roomGroup && roomGroup.text ? roomGroup.text.name : null
        })))));
        // const content = [].push()
        context.commit('mapWidget/SET_LOCATIONS', positions, { root: true });
        context.commit('SET_RESULTS', roomGroups);
      } else {
        //TODO catch errors
      }
      context.commit('SET_LOADING', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/booking-step1.store.js